import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

const LogoutComplete: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginAgain = () => {
    // Navigate to login page (which will trigger OAuth)
    navigate('/login');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <LogoutIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Successfully Logged Out
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You have been successfully logged out of your account. 
            All sessions have been cleared and your data is secure.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleLoginAgain}
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
            }}
          >
            Login Again
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default LogoutComplete; 
